import { useEffect } from "react";
import { AUTH_URL } from "../../config/env";

// redirect to auth service for forgot password
const ForgotPasswordPage = () => {
  useEffect(() => {
    // redirect to auth service forgot password page
    window.location.href = `${AUTH_URL}/forgot-password`;
  }, []);

  // show loading while redirecting
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#9f8aff",
      }}
    >
      <p>Redirecting to password reset...</p>
    </div>
  );
};

export default ForgotPasswordPage;
